import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { PourTypeDeleteCard } from './components/PourTypeDeleteCard';
import { PourTypeDetailsCard } from './components/PourTypeDetailsCard';

// import { ProductsCard } from './components/ProductsCard';

export function PourTypeDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const pourTypeQueryResults = useQuery({
        queryKey: ['pourType', id],
        queryFn: () => Api.Servings.PourType.getPourType(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={pourTypeQueryResults}>
                {data => {
                    return (
                        <Stack gap={2} sx={{ paddingBottom: 4 }}>
                            <PourTypeDetailsCard pourType={data} />
                            {/* <ProductsCard
                                pourType={data}
                                refetch={pourTypeQueryResults.refetch}
                            /> */}

                            <Can I="delete" a="PourType">
                                <PourTypeDeleteCard pourType={data} />
                            </Can>
                        </Stack>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
